module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "aboutAuthorPage"
  }, [_c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('div', {
    staticClass: "title-aboutAuthorPage"
  }, [_c('div', {
    staticClass: "p-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ELIZABETH BEVARLY")])]), _c('br'), _vm._v(" is an honors graduate of the University of Louisville and achieved her dream of writing full-time before she even turned thirty! At heart, she is also an avid voyager who once helped navigate a friend’s thirty-five-foot sailboat across the Bermuda Triangle. “I really love to travel,” says this self-avowed beach bum. “To me, it’s the best education a person can give to herself.” Her dream is to one day have her own sailboat, a beautifully renovated older model forty-two footer, and to enjoy the freedom and tranquillity seafaring can bring. Elizabeth likes to think she has a lot in common with the characters she creates, people who know love and life go hand in hand. And she’s getting some firsthand experience with maternity, as well—she and her husband welcomed their firstborn, a son, two years ago.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-937cca4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459271517_ata01.vue
// module id = 72
// module chunks = 0